var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supplier"},[_c('van-list',{attrs:{"finished":_vm.finished,"finished-text":_vm.$t.noMoreData},on:{"load":_vm.onLoad},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('div',{staticClass:"list"},[_c('supplier-list',{attrs:{"listSupplier":_vm.listSupplier}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }